import * as React from 'react';
import DialogActions from '@mui/material/DialogActions';
import { styled, ThemeProvider } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Button, FormControlLabel, Checkbox, Box } from '@mui/material';
import { theme } from '../../../theme/theme';
import { BOGLE_REGULAR } from '../../../constants/constant';

const BootstrapButton = styled(Button)(() => ({
	borderRadius: '100px',
	textTransform: 'none',
	fontFamily: BOGLE_REGULAR,
	fontWeight: 600,
	boxShadow: 'none',
	'&:hover': {
		boxShadow: 'none',
	},
}));
function ModalDialogAction({ handleClose, handleSave, isValid }) {
	const [isDefault, setIsDefault] = React.useState(false);
	return (
		<ThemeProvider theme={theme}>
			<DialogActions
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: '24px',
					height: '40px',
					padding: 0,
				}}>
				<FormControlLabel
					data-testid="set-defaul-btn"
					sx={{
						marginRight: 0,
						'& .MuiFormControlLabel-label': {
							fontFamily: 'Bogle',
							fontSize: '16px',
							fontWeight: '400',
							lineHeight: '24px',
						},
					}}
					control={
						<Checkbox
							checked={isDefault}
							onChange={(e) => setIsDefault(e.target.checked)}
						/>
					}
					label="Save as my default"
				/>
				<Box display={'flex'} gap={'16px'}>
					<BootstrapButton
						data-testid="cancel-save-hierarchy-btn"
						sx={{
							borderColor: '#D5D6D8',
						}}
						onClick={handleClose}
						variant="outlined">
						Cancel
					</BootstrapButton>
					<BootstrapButton
						data-testid="save-hierarchy-btn"
						disableRipple
						variant="contained"
						onClick={() => handleSave(isDefault)}
						sx={{
							'&.Mui-disabled': {
								color: 'white',
								backgroundColor: '#BABBBE',
							},
						}}
						disabled={!isValid}>
						Save
					</BootstrapButton>
				</Box>
			</DialogActions>
		</ThemeProvider>
	);
}

ModalDialogAction.propTypes = {
	handleClose: PropTypes.func.isRequired,
	handleSave: PropTypes.func.isRequired,
	isValid: PropTypes.bool.isRequired,
};

export default ModalDialogAction;
